import { pageTypes } from 'common/constants/pageTypes'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from '../enums/entityTypeEnum'
import { PageTypeEnum } from '../enums/PageTypeEnum'

const contactUsEntities = [
  EntityTypeEnum.ContactUs,
  EntityTypeEnum.Field,
  EntityTypeEnum.ContactUsField,
  EntityTypeEnum.TextArea,
  EntityTypeEnum.Attachments,
  EntityTypeEnum.Recaptcha,
  EntityTypeEnum.ContactUsRecaptcha,
  EntityTypeEnum.ContactUsButton,
  EntityTypeEnum.Button, // todo remove https://app.shortcut.com/systeme/story/45859/remove-button-usage-after-migrating-to-contactusbutton
]

const websiteEntityTypes = [
  EntityTypeEnum.WebsiteLayoutBody,
  EntityTypeEnum.WebsitePageBody,
  EntityTypeEnum.WebsiteHeader,
  EntityTypeEnum.WebsiteFooter,
  EntityTypeEnum.WebsiteLogo,
  EntityTypeEnum.WebsiteButton,
  EntityTypeEnum.WebsiteLogin,
  EntityTypeEnum.WebsiteLanguageSwitcher,
  EntityTypeEnum.LoginButton,
  EntityTypeEnum.RegistrationButton,
]

const common = [
  structureTypes.SECTION,
  EntityTypeEnum.Section,
  structureTypes.ROW,
  EntityTypeEnum.Row,
  structureTypes.BODY,
  EntityTypeEnum.Body,
  structureTypes.ROW,
  structureTypes.COLUMN,
  EntityTypeEnum.Column,
  EntityTypeEnum.Headline,
  structureTypes.BUTTON,
  structureTypes.FORM_INPUT,
  EntityTypeEnum.Field,
  structureTypes.IMAGE,
  EntityTypeEnum.Popup,
  EntityTypeEnum.RemotePopupBody,
  EntityTypeEnum.InlineBody,
  structureTypes.AUDIO,
  structureTypes.CONTENT_BOX,
  EntityTypeEnum.ContentBox,
  EntityTypeEnum.FacebookComments,
  EntityTypeEnum.Countdown,
  EntityTypeEnum.Menu,
  EntityTypeEnum.HorizontalLine,
  structureTypes.LANGUAGE_SWITCHER,
  EntityTypeEnum.PricePlanCalculator,
  EntityTypeEnum.TwitterTweetButton,
  structureTypes.SURVEY,
  EntityTypeEnum.Carousel,
  EntityTypeEnum.CarouselItem,
  EntityTypeEnum.Faq,
  EntityTypeEnum.FaqItem,
  EntityTypeEnum.Text,
  EntityTypeEnum.Image,
  EntityTypeEnum.Survey,
  EntityTypeEnum.Video,
  EntityTypeEnum.FormInput,
  EntityTypeEnum.Audio,
  EntityTypeEnum.OptInRecaptcha,
  EntityTypeEnum.LanguageSwitcher,
  EntityTypeEnum.RawHtml,
  EntityTypeEnum.Checkbox,
  EntityTypeEnum.BulletList,
  EntityTypeEnum.Button,
]

const websiteCommon = [
  EntityTypeEnum.Row,
  EntityTypeEnum.Column,
  EntityTypeEnum.Headline,
  EntityTypeEnum.Field,
  EntityTypeEnum.Popup,
  EntityTypeEnum.InlineBody,
  EntityTypeEnum.ContentBox,
  EntityTypeEnum.FacebookComments,
  EntityTypeEnum.Countdown,
  EntityTypeEnum.Menu,
  EntityTypeEnum.HorizontalLine,
  EntityTypeEnum.PricePlanCalculator,
  EntityTypeEnum.TwitterTweetButton,
  EntityTypeEnum.Carousel,
  EntityTypeEnum.CarouselItem,
  EntityTypeEnum.Faq,
  EntityTypeEnum.FaqItem,
  EntityTypeEnum.Text,
  EntityTypeEnum.Image,
  EntityTypeEnum.Survey,
  EntityTypeEnum.Video,
  EntityTypeEnum.FormInput,
  EntityTypeEnum.Audio,
  EntityTypeEnum.OptInRecaptcha,
  EntityTypeEnum.LanguageSwitcher,
  EntityTypeEnum.RawHtml,
  EntityTypeEnum.Checkbox,
  EntityTypeEnum.BulletList,
  EntityTypeEnum.Button,
]

export const getPageTypeEntities = pageType => {
  let additionalEntities = []
  switch (pageType) {
    case pageTypes.offerInner:
    case pageTypes.offerPage:
      additionalEntities = [
        EntityTypeEnum.Coupon,
        structureTypes.PAYMENT_BUTTON,
        EntityTypeEnum.PaymentButton,
        structureTypes.CUSTOMER_TYPE,
        EntityTypeEnum.CustomerType,
        structureTypes.ORDER_BUMP,
        EntityTypeEnum.OrderBump,
        structureTypes.PHYSICAL_PRODUCT,
        EntityTypeEnum.OfferPrice,
        structureTypes.TWO_STEP_PAYMENT_FORM,
        EntityTypeEnum.TwoStepPaymentForm,
        structureTypes.TWO_STEP_PAYMENT_FORM_STEP_OPT_IN,
        EntityTypeEnum.TwoStepPaymentFormStepOptIn,
        structureTypes.TWO_STEP_PAYMENT_FORM_STEP_PAYMENT,
        EntityTypeEnum.TwoStepPaymentFormStepPayment,
        structureTypes.PAYMENT_METHOD,
        EntityTypeEnum.PaymentMethod,
        structureTypes.AGREEMENT,
        EntityTypeEnum.Product,
        EntityTypeEnum.ShippingFees,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.BookingPaidCalendar,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.salesPage:
      additionalEntities = [
        EntityTypeEnum.SalesRedirectionButton,
        structureTypes.PHYSICAL_PRODUCT,
        structureTypes.AGREEMENT,
        EntityTypeEnum.Product,
        EntityTypeEnum.ShippingFees,
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.PriceElement,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.offerUpSellPage:
      additionalEntities = [
        EntityTypeEnum.UpsellAgreeButton,
        EntityTypeEnum.UpsellDisagreeButton,
        structureTypes.PHYSICAL_PRODUCT,
        EntityTypeEnum.OfferPrice,
        structureTypes.AGREEMENT,
        EntityTypeEnum.Product,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.BookingPaidCalendar,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.OfferInnerThankYouPage:
    case pageTypes.offerThankYouPage:
      additionalEntities = [
        EntityTypeEnum.OrderSummary,
        structureTypes.AGREEMENT,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.customLogin:
      additionalEntities = [
        EntityTypeEnum.CustomLogin,
        EntityTypeEnum.CustomLoginForgotPassword,
      ]
      break
    case pageTypes.webinarRegistration:
      additionalEntities = [
        EntityTypeEnum.WebinarRegistrationDate,
        structureTypes.START_TIMER,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.webinarSession:
      additionalEntities = [
        EntityTypeEnum.WebinarSessionVideo,
        EntityTypeEnum.WebinarCallToAction,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.webinarThankYou:
      additionalEntities = [
        EntityTypeEnum.WebinarSessionLink,
        EntityTypeEnum.WebinarSessionDateTime,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.blogPostLayout:
      additionalEntities = [
        structureTypes.BLOG_POST_BODY,
        EntityTypeEnum.BlogPostBody,
        EntityTypeEnum.BlogPostContentPlaceholder,
        EntityTypeEnum.Search,
        structureTypes.BLOG_POST_CONTENT_PLACEHOLDER,
        structureTypes.BLOG_POST_LAYOUT_BODY,
        EntityTypeEnum.BlogPostLayoutBody,
        structureTypes.BLOG_CONTENT_PLACEHOLDER,
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.Breadcrumbs,
        EntityTypeEnum.BlogPostDate,
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.BlogPostCategories,
        EntityTypeEnum.BlogPostTitle,
        EntityTypeEnum.BlogPostImage,
        EntityTypeEnum.LatestBlogPosts,
        EntityTypeEnum.LatestBlogPostsCarousel,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogHome:
    case pageTypes.blogPostListing:
    case pageTypes.blogStatic:
    case pageTypes.blogSearch:
      additionalEntities = [
        EntityTypeEnum.BlogPostListing,
        EntityTypeEnum.SearchResults,
        EntityTypeEnum.Search,
        EntityTypeEnum.LatestBlogPosts,
        structureTypes.BLOG_CONTENT_PLACEHOLDER,
        EntityTypeEnum.BlogContentPlaceholder,
        structureTypes.BLOG_PAGE_BODY,
        EntityTypeEnum.BlogPageBody,
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Attachments,
        EntityTypeEnum.Recaptcha,
        EntityTypeEnum.Button,
        EntityTypeEnum.BlogCategoryTitle,
        EntityTypeEnum.BlogCategoryDescription,
        EntityTypeEnum.LatestBlogPostsCarousel,
        EntityTypeEnum.BookingCalendar,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogPostBody:
      additionalEntities = [
        EntityTypeEnum.ContentTable,
        structureTypes.BLOG_POST_BODY,
        EntityTypeEnum.BlogPostBody,
        EntityTypeEnum.BlogPostContentPlaceholder,
        EntityTypeEnum.Search,
        structureTypes.BLOG_POST_CONTENT_PLACEHOLDER,
        structureTypes.BLOG_CONTENT_PLACEHOLDER,
        EntityTypeEnum.BlogContentPlaceholder,
        structureTypes.BLOG_POST_LAYOUT_BODY,
        EntityTypeEnum.BlogPostLayoutBody,
        EntityTypeEnum.Breadcrumbs,
        EntityTypeEnum.BlogPostDate,
        EntityTypeEnum.BlogPostCategories,
        EntityTypeEnum.BlogPostTitle,
        EntityTypeEnum.BlogPostImage,
        EntityTypeEnum.LatestBlogPosts,
        EntityTypeEnum.LatestBlogPostsCarousel,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogLayout:
      additionalEntities = [
        structureTypes.BLOG_CONTENT_PLACEHOLDER,
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.Search,
        ...contactUsEntities,
      ]
      break
    case PageTypeEnum.FunnelContactUs:
      additionalEntities = [
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.Field,
        EntityTypeEnum.ContactUsField,
        EntityTypeEnum.ContactUsButton,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Attachments,
        EntityTypeEnum.Recaptcha,
        EntityTypeEnum.ContactUsRecaptcha,
        EntityTypeEnum.Button,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.Lecture:
      additionalEntities = [
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Button,
      ]
      break
    case PageTypeEnum.Inline:
      additionalEntities = [EntityTypeEnum.BookingCalendar, EntityTypeEnum.Form]
      break
    case PageTypeEnum.Squeeze:
      additionalEntities = [
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.BookingCalendarPreview,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.Popup:
      additionalEntities = [EntityTypeEnum.BookingCalendar, EntityTypeEnum.Form]
      break
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteLayout:
    case PageTypeEnum.WebsiteDefault:
    case PageTypeEnum.WebsiteLogin:
      additionalEntities = [
        ...websiteEntityTypes,
        EntityTypeEnum.Form,
        EntityTypeEnum.BookingCalendar,
      ]
      return websiteCommon.concat(additionalEntities)
    case PageTypeEnum.WebsitePricing:
      additionalEntities = [...websiteEntityTypes, EntityTypeEnum.PriceElement]
      return websiteCommon.concat(additionalEntities)
    case PageTypeEnum.BookingCalendarPreview:
      additionalEntities = [EntityTypeEnum.BookingCalendarPreview]
      break
    default:
      additionalEntities = []
  }

  return common.concat(additionalEntities)
}
